<template>
  <v-container
    fluid
    class="accounts-revamp accounts-revamp--modern oms-list-page oms-list-page--accounts oms-list-page--compact-table"
  >
    <v-card raised class="accounts-panel oms-list-panel">
      <v-flex class="accounts-tabs-region">
        <slot name="tabs" />
      </v-flex>

      <slot />
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "FinanceControlShell",
};
</script>

<style scoped>
.accounts-revamp {
  background: var(--oms-bg, #f6f5f2);
  color: var(--oms-ink, #3a382f);
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  min-height: calc(100vh - 3.375rem);
  padding: var(--oms-list-page-padding, 1.625rem 1.75rem) !important;
}

.accounts-panel {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: var(--oms-radius, 1rem) !important;
  box-shadow: var(--oms-shadow, 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.04)) !important;
  overflow: visible;
}

.accounts-tabs-region {
  align-items: center;
  background: var(--oms-surface, #ffffff);
  border-bottom: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: var(--oms-radius, 1rem) var(--oms-radius, 1rem) 0 0;
  display: flex;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.75rem var(--oms-list-section-x, 1.75rem);
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 47.5rem) {
  .accounts-revamp {
    padding: 1rem !important;
  }
}
</style>
